import React from 'react';
import "./experience.css";
import ExperienceItem from '../../components/ExperienceItem';

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5><br /><br />
      <h2>My Experience</h2>

      <div className="container experience__container">

        {/* Frontend Section */}
        <div className="experience__frontend">
          <p className='exp_title'>Frontend Development</p>
          <div className="experience__content">
            {["HTML", "CSS", "JavaScript", "React", "Bootstrap", "Angular"].map(skill => (
              <ExperienceItem key={skill} title={skill} />
            ))}
          </div>
        </div>

        {/* Backend Section */}
        <div className="experience__backend">
          <p className='exp_title'>Backend Development</p>
          <div className="experience__content">
            {["Node.js", "MongoDB", "Mongoose", "SQL Server", "SQL", "Express.js", "JavaScript", "ASP.Net"].map(skill => (
              <ExperienceItem key={skill} title={skill} />
            ))}
          </div>
        </div>

        {/* Cloud & Other Technologies */}
        <div className="experience__frontend">
          <p className='exp_title'>Cloud Technologies</p>
          <div className="experience__content">
            {["Microsoft Azure", "Google Cloud", "Azure Service Bus", "Azure APIM", "Azure Event Grid", "Blob Storage", "Docker"].map(tech => (
              <ExperienceItem key={tech} title={tech} />
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="experience__frontend">
          <p className='exp_title'>Programing Languages & Others</p>
          <div className="experience__content">
            {["C++", "Java" , "C#" , "Javascript","Git", "GitHub", "Visual Studio", "Vs Code","Eclipse"].map(cert => (
              <ExperienceItem key={cert} title={cert} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Experience;
